import MembersCell from '../columns/Members/MembersCell';
import DropdownCell from '../columns/NestingDropdown/DropdownCell';
import TeamCell from '../columns/Team/TeamCell';
import { handleTeamSettingsModalProps } from '../teamTableTypes';

export default function Row({
  cellData,
  subRows,
  colKey,
  level,
  handleTeamSettingsModal,
  lastVisibleName,
}: {
  level: number;
  cellData: any;
  colKey: string;
  subRows: any;
  handleTeamSettingsModal?: handleTeamSettingsModalProps;
  lastVisibleName?: string;
}) {
  return colKey === 'TEAM' ? (
    <TeamCell
      level={level}
      cellData={cellData}
      subRows={subRows}
      handleTeamSettingsModal={handleTeamSettingsModal}
    />
  ) : colKey === 'MEMBERS' ? (
    <MembersCell level={level} cellData={cellData} subRows={subRows} />
  ) : colKey === 'DROPDOWN' ? (
    <DropdownCell
      level={level}
      cellData={cellData}
      subRows={subRows}
      lastVisibleName={lastVisibleName}
    />
  ) : (
    <></>
  );
}
